import { baseApi } from './baseApi';

export const aboutApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get about information
    getAbout: builder.query({
      query: () => ({
        url: 'about/get',
        method: 'GET',
      }),
      providesTags: ['About'],
    }),

    // Update about information
    editAbout: builder.mutation({
      query: (body) => ({
        url: 'about/update',
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['About'],
    }),

    // Create award
    createAward: builder.mutation({
      query: (body) => ({
        url: 'about/create-award',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['About'],
    }),

    // Delete award
    deleteAward: builder.mutation({
      query: (awardId) => ({
        url: `about/delete-award/${awardId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['About'],
    }),
  }),
});

export const {
  useGetAboutQuery,
  useEditAboutMutation,
  useCreateAwardMutation,
  useDeleteAwardMutation,
} = aboutApi;